import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Space,
  Spin,
  Table,
} from "antd";
import {
  ColumnsClient,
  ColumnsClientBank,
  ColumnsClientCsv,
  ColumnsCsvClient,
} from "./columns-table";
import {
  notificationErroInternal,
  notificationInfo,
  notificationSucess,
} from "util/api-utils";
import {
  deleteCompany,
  deleteCompanyBank,
  getAllBanks,
  getCompanies,
  integrationImport,
  putBank,
  putCompany,
  saveBank,
  saveCompany,
  integrationImportPlan,
} from "services/client/client-service";
import { ExclamationCircleFilled, SearchOutlined } from "@ant-design/icons";
import { cnpjMask } from "util/mask-cnpj";
import Highlighter from "react-highlight-words";
import { CSVLink } from "react-csv";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useSelector } from "react-redux";
import { selectRole } from "reducer/login/login-user";
import { ROLE_USER_ADMIN, USER_STORAGE } from "../../../constants";
dayjs.extend(customParseFormat);

const dateFormat = "DD/MM/YYYY";

const { confirm } = Modal;

const Clients = () => {
  const [loadingData, setLoadingData] = useState(true);
  const [data, setData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const formRef = React.useRef(null);
  const [editId, setEditId] = useState(null);
  const formRefBank = React.useRef(null);
  const [isModalOpenBank, setIsModalOpenBank] = useState(false);
  const [banks, setBanks] = useState([]);
  const [clientId, setClientId] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = React.useRef(null);
  const [dataCsv, setDataCsv] = useState([]);
  const [selectType, setSelectType] = useState(null);

  const [roleRedux, setRoleRedux] = useState(useSelector(selectRole));
  const [quantityUser, setQuantityUser] = useState(0);

  useEffect(() => {
    const localStorageItem = localStorage.getItem(USER_STORAGE);
    if (localStorageItem != null) {
      const { role, quantityUser } = JSON.parse(localStorageItem);
      setQuantityUser(quantityUser);
      if (roleRedux == "" || role != roleRedux) {
        setRoleRedux(role);
      }
    }
  }, []);

  useEffect(() => {
    getCompaniesData();
  }, []);

  function getCompaniesData() {
    getCompanies()
      .then((res) => {
        res = res.map((obj) => ({
          ...obj,
          disable: disable,
          edit: edit,
          newBank: showModalBank,
          activeString: obj.active ? "Ativo" : "Desativado",
          import: importData,
          importPlan: importPlan,
        }));
        res.forEach((element) => {
          element.banks = element.banks.map((obj) => ({
            ...obj,
            edit: editBank,
            disable: disableBank,
          }));
        });

        setLoadingData(false);
        let csvData = [];
        res.forEach((element) => {
          if (element.banks.length > 0) {
            element.banks.forEach((bank) => {
              csvData.push({
                ...element,
                codeAccount: bank.codeAccount,
                description: bank.description,
              });
            });
          } else {
            csvData.push({
              ...element,
            });
          }
        });

        setDataCsv(csvData);
        setData(res);
      })
      .catch((err) => {
        setLoadingData(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
    getAllBanks()
      .then((res) => {
        let selectBank = res.map((obj) => ({
          value: obj.id,
          label: obj.name,
        }));
        setBanks(selectBank);
      })
      .catch((err) => {
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }

  const showModal = () => {
    setIsModalOpen(true);
    setSelectType(null);
  };
  const showModalBank = (row) => {
    setIsModalOpenBank(true);
    setClientId(row.id);
  };
  const importData = (row) => {
    setLoadingData(true);
    integrationImport(row.id)
      .then(() => {
        notificationSucess();
        getCompaniesData();
      })
      .catch((err) => {
        notificationInfo(
          "Muitos dados para processamento, aguarde 10 minutos e verifique se os dados foram importados!"
        );
        getCompaniesData();
      });
  };
  const importPlan = (row) => {
    setLoadingData(true);
    integrationImportPlan(row.id)
      .then(() => {
        notificationSucess();
        getCompaniesData();
      })
      .catch((err) => {
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
        getCompaniesData();
      });
  };
  const handleOk = () => {
    formRef.current
      .validateFields()
      .then((values) => {
        setLoadingData(true);
        setIsModalOpen(false);
        values.cnpj = cnpjMask(values.cnpj);
        if (editId !== null) {
          put(values);
        } else {
          save(values);
        }
      })
      .catch((errors) => {
        console.log(errors);
      });
  };
  const handleOkBank = () => {
    formRefBank.current
      .validateFields()
      .then((values) => {
        setLoadingData(true);
        setIsModalOpenBank(false);
        if (editId !== null) {
          putBankValue(values);
        } else {
          saveBankValue(values);
        }
      })
      .catch((errors) => {
        console.log(errors);
      });
  };
  const handleCancel = () => {
    formRef.current?.resetFields();
    setEditId(null);
    setIsModalOpen(false);
  };
  const handleCancelBank = () => {
    formRefBank.current?.resetFields();
    setIsModalOpenBank(false);
    setClientId(null);
  };

  function save(values) {
    if (roleRedux == ROLE_USER_ADMIN && quantityUser == data.length) {
      notificationInfo("Seu plano atingiu o limite de empresas cadastradas");
      setLoadingData(false);
      formRef.current?.resetFields();
      return;
    }
    saveCompany(values)
      .then(() => {
        notificationSucess();
        formRef.current?.resetFields();
        getCompaniesData();
      })
      .catch((err) => {
        setLoadingData(false);
        formRef.current?.resetFields();
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  function saveBankValue(values) {
    values.clientId = clientId;
    values.dateBalance = values.dateBalance.format(dateFormat);
    saveBank(values)
      .then(() => {
        notificationSucess();
        formRefBank.current?.resetFields();
        getCompaniesData();
      })
      .catch((err) => {
        setLoadingData(false);
        formRefBank.current?.resetFields();
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  function putBankValue(values) {
    values.clientId = clientId;
    values.id = editId;
    values.dateBalance = values.dateBalance.format(dateFormat);
    putBank(values)
      .then(() => {
        notificationSucess();
        formRefBank.current?.resetFields();
        setEditId(null);
        getCompaniesData();
      })
      .catch((err) => {
        setLoadingData(false);
        setEditId(null);
        formRefBank.current?.resetFields();
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  function put(values) {
    values.id = editId;
    putCompany(values)
      .then(() => {
        notificationSucess();
        setEditId(null);
        formRef.current?.resetFields();
        getCompaniesData();
      })
      .catch((err) => {
        setLoadingData(false);
        setEditId(null);
        formRef.current?.resetFields();
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }

  function editBank(row) {
    showModalBank({ id: row.clientId });
    setEditId(row.id);
    setTimeout(() => {
      formRefBank.current?.setFieldsValue({
        bankId: row.bankId,
        balance: row.balance,
        limit: row.limit,
        description: row.description,
        dateBalance: dayjs(row.dateBalance, dateFormat),
        isSumAmount: row.sumAmount,
      });
    }, 300);
  }

  function edit(row) {
    showModal();
    setEditId(row.id);
    setSelectType(row.integrationType);

    setTimeout(() => {
      formRef.current?.setFieldsValue({
        cnpj: row.document,
        client: row.name,
        appKey: row.appKey,
        appSecret: row.appSecret,
        appToken: row.appToken,
        budget: row.budget,
        integrationType: row.integrationType,
        urlBi: row.urlBi
      });
    }, 300);
  }
  function disable(row) {
    confirm({
      title: "Tem certeza que deseja deletar o cliente '" + row.name + "' ?",
      icon: <ExclamationCircleFilled />,
      okText: "Sim",
      okType: "danger",
      cancelText: "Não",
      onOk() {
        setLoadingData(true);
        deleteCompany(row.id)
          .then(() => {
            notificationSucess();
            getCompaniesData();
          })
          .catch((err) => {
            setLoadingData(false);
            notificationErroInternal(
              "Aconteceu um erro inesperado, por favor, tente mais tarde."
            );
          });
      },
      onCancel() {},
    });
  }

  function disableBank(row) {
    confirm({
      title:
        "Tem certeza que deseja deletar a conta '" + row.description + "' ?",
      icon: <ExclamationCircleFilled />,
      okText: "Sim",
      okType: "danger",
      cancelText: "Não",
      onOk() {
        setLoadingData(true);
        deleteCompanyBank(row.id)
          .then(() => {
            notificationSucess();
            getCompaniesData();
          })
          .catch((err) => {
            setLoadingData(false);
            notificationErroInternal(
              "Aconteceu um erro inesperado, por favor, tente mais tarde."
            );
          });
      },
      onCancel() {},
    });
  }
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex, tittle) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Buscar ${tittle}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Limpar
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Fechar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  let columnFilter = ColumnsClient.filter(
    (item) => item.dataIndex != "action"
  ).map((item) => ({
    ...item,
    ...getColumnSearchProps(item.dataIndex, item.title),
  }));
  const action = ColumnsClient.filter((item) => item.dataIndex == "action");
  columnFilter.push(action[0]);
  return (
    <div className="container-client">
      <Card
        className="card-client"
        title="Clientes"
        extra={
          <Space>
            <CSVLink
              filename={"clientes.csv"}
              className="btn btn-primary"
              data={dataCsv}
              headers={ColumnsClientCsv}
              style={{ borderRadius: "6px" }}
            >
              Baixar
            </CSVLink>

            <Button
              type="primary"
              className="button-client"
              onClick={showModal}
            >
              Novo Cliente
            </Button>
          </Space>
        }
        bordered={false}
      >
        <Spin spinning={loadingData} size={"large"}>
          <Table
            columns={columnFilter}
            dataSource={data}
            size="small"
            pagination={{ pageSize: 10 }}
            locale={{
              emptyText: "Sem registro",
            }}
            expandable={{
              expandedRowRender: (record) => (
                <Table
                  pagination={false}
                  dataSource={record.banks}
                  columns={ColumnsClientBank}
                />
              ),
            }}
          />
        </Spin>
      </Card>
      <Modal
        style={{ textAlign: "center" }}
        title="Novo Cliente"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form ref={formRef} style={{ maxWidth: 600 }}>
          <Form.Item
            name="cnpj"
            label="CNPJ"
            rules={[
              { required: true, message: "É necessário informar o cnpj" },
            ]}
          >
            <Input style={{ width: "93%", marginLeft: "15px" }} />
          </Form.Item>
          <Form.Item
            name="client"
            label="Cliente"
            rules={[
              { required: true, message: "É necessário informar o cliente" },
            ]}
          >
            <Input style={{ width: "94%", marginLeft: "10px" }} />
          </Form.Item>
          <Form.Item
            name="integrationType"
            label="Tipo"
            rules={[
              { required: true, message: "É necessário informar o tipo" },
            ]}
          >
            <Select
              style={{ width: "91%", marginLeft: "30px" }}
              placeholder="Selecione um tipo"
              allowClear
              onChange={(event) => {
                setSelectType(event);
              }}
            >
              <Option value="BI">BI</Option>
              <Option value="BI_V2">BI V2</Option>
              <Option value="CONTA_AZUL">Conta Azul</Option>
              <Option value="NIBO">Nibo</Option>
              <Option value="OMIE">Omie</Option>
              <Option value="EVERFLOW">Everflow</Option>
              <Option value="F360">F360</Option>
              <Option value="BOM_CONTROLE">Bom Controle</Option>
              <Option value="IMPORT">Planilha</Option>
            </Select>
          </Form.Item>
          {selectType == "BI" && (
            <Form.Item
              name="urlBi"
              label="BI"
              rules={[
                {
                  required: true,
                  message: "É necessário informar a url do BI",
                },
              ]}
            >
              <Input style={{ width: "94%", marginLeft: "10px" }} />
            </Form.Item>
          )}
        {selectType == "BI_V2" && (
            <>
              <Form.Item
                name="appKey"
                label="Workspace ID"
                rules={[
                  {
                    required: true,
                    message: "É necessário informar o workspace id",
                  },
                ]}
              >
                <Input style={{ width: "94%", marginLeft: "10px" }} />
              </Form.Item>
              <Form.Item
                name="appSecret"
                label="Report ID"
                rules={[
                  {
                    required: true,
                    message: "É necessário informar o report id",
                  },
                ]}
              >
                <Input style={{ width: "94%", marginLeft: "10px" }} />
              </Form.Item>
            </>
          )}
          {selectType == "CONTA_AZUL" && (
            <>
              <Form.Item
                name="appKey"
                label="Email"
                rules={[
                  {
                    required: true,
                    message: "É necessário informar a email conta azul",
                  },
                ]}
              >
                <Input style={{ width: "94%", marginLeft: "10px" }} />
              </Form.Item>
              <Form.Item
                name="appSecret"
                label="Senha"
                rules={[
                  {
                    required: true,
                    message: "É necessário informar o senha conta azul",
                  },
                ]}
              >
                <Input style={{ width: "94%", marginLeft: "10px" }} />
              </Form.Item>
            </>
          )}
          {selectType == "OMIE" && (
            <>
              <Form.Item
                name="appKey"
                label="Key Omie"
                rules={[
                  {
                    required: true,
                    message: "É necessário informar a key omie",
                  },
                ]}
              >
                <Input style={{ width: "94%", marginLeft: "10px" }} />
              </Form.Item>
              <Form.Item
                name="appSecret"
                label="Secrety Omie"
                rules={[
                  {
                    required: true,
                    message: "É necessário informar o secrety omie",
                  },
                ]}
              >
                <Input style={{ width: "94%", marginLeft: "10px" }} />
              </Form.Item>
            </>
          )}
          {selectType == "EVERFLOW" && (
            <Form.Item
              name="appToken"
              label="Token Everflow"
              rules={[
                {
                  required: true,
                  message: "É necessário informar o token everflow",
                },
              ]}
            >
              <Input style={{ width: "94%", marginLeft: "10px" }} />
            </Form.Item>
          )}
          {selectType == "NIBO" && (
            <Form.Item
              name="appToken"
              label="Token Nibo"
              rules={[
                {
                  required: true,
                  message: "É necessário informar o token nibo",
                },
              ]}
            >
              <Input style={{ width: "94%", marginLeft: "10px" }} />
            </Form.Item>
          )}
          {selectType == "F360" && (
            <Form.Item
              name="appToken"
              label="Token F360"
              rules={[
                {
                  required: true,
                  message: "É necessário informar o token F360",
                },
              ]}
            >
              <Input style={{ width: "94%", marginLeft: "10px" }} />
            </Form.Item>
          )}
          {selectType == "BOM_CONTROLE" && (
            <Form.Item
              name="appToken"
              label="Token Bom Controle"
              rules={[
                {
                  required: true,
                  message: "É necessário informar o token Bom Controle",
                },
              ]}
            >
              <Input style={{ width: "94%", marginLeft: "10px" }} />
            </Form.Item>
          )}
          <Form.Item
            name="budget"
            label="Orçamento"
            rules={[
              { required: true, message: "É necessário informar o orçamento" },
            ]}
          >
            <Select
              style={{ width: "91%", marginLeft: "30px" }}
              placeholder="Mostrar Orçamento"
              allowClear
            >
              <Option value={true}>Sim</Option>
              <Option value={false}>Não</Option>
            </Select>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        style={{ textAlign: "center" }}
        title="Novo Banco"
        open={isModalOpenBank}
        onOk={handleOkBank}
        onCancel={handleCancelBank}
      >
        <Form ref={formRefBank} style={{ maxWidth: 600 }}>
          <Form.Item
            name="bankId"
            label="Banco"
            rules={[
              { required: true, message: "É necessário informar o banco" },
            ]}
          >
            <Select
              style={{ width: "94%", marginLeft: "20px" }}
              placeholder="Selecione o banco"
              options={banks}
            />
          </Form.Item>
          <Form.Item
            name="description"
            label="Conta"
            rules={[
              { required: true, message: "É necessário informar uma Conta" },
            ]}
          >
            <Input style={{ width: "93%", marginLeft: "20px" }} />
          </Form.Item>

          <Form.Item
            name="dateBalance"
            label="Data do saldo"
            rules={[
              {
                required: true,
                message: "É necessário informar a data do saldo",
              },
            ]}
          >
            <DatePicker
              style={{ width: "100%" }}
              format={dateFormat}
              placeholder="Selecione o data do saldo"
              allowClear={false}
            />
          </Form.Item>

          <Form.Item
            name="balance"
            label="Saldo"
            rules={[
              { required: true, message: "É necessário informar o Saldo" },
            ]}
          >
            <InputNumber
              decimalSeparator=","
              precision={2}
              formatter={(value) => `R$ ${value}`}
              parser={(value) => value.replace(/R\$\s?/, "")}
              style={{ width: "92%", marginLeft: "20px" }}
            />
          </Form.Item>
          <Form.Item
            name="limit"
            label="Limite"
            rules={[
              { required: true, message: "É necessário informar o Limite" },
            ]}
          >
            <InputNumber
              decimalSeparator=","
              precision={2}
              formatter={(value) => `R$ ${value}`}
              parser={(value) => value.replace(/R\$\s?/, "")}
              style={{ width: "92%", marginLeft: "20px" }}
            />
          </Form.Item>
          <Form.Item
            name="isSumAmount"
            label="Somar no saldo"
            rules={[
              {
                required: true,
                message: "É necessário informar o se é preciso somar no saldo",
              },
            ]}
          >
            <Select style={{ width: "91%", marginLeft: "30px" }}>
              <Option value={true}>Sim</Option>
              <Option value={false}>Não</Option>
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};
export default Clients;
